import "./Preloader.css";

export default function Preloader() {
  return <div className="circle-preloader"></div>;
}
